export default __webpack_public_path__ + "static/hm-volume-miracle-fdb14732559dd0b7bc0b70e9789fcae6.webp";